import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling + provides a global smooth scroll-to helper.
export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Expose a scroll-to for anchor buttons.
    window.__lenisScrollTo = (target, opts = {}) => {
      lenis.scrollTo(target, { offset: -10, duration: 1.4, ...opts });
    };

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenisScrollTo;
    };
  }, []);
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenisScrollTo) {
    window.__lenisScrollTo(el);
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
